(function () {
    const classShow = 'pageLayout__headline__layout__inner--show';

    document.fonts.ready.then(() => {
        const swiper = new Swiper('.swiper', {
            // Optional parameters
            loop: true,
            autoplay: {
                delay: 4000,
            },
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 1500,
            allowTouchMove: false, // Disable touch and mouse dragging
            keyboard: false,       // Disable keyboard navigation
            mousewheel: false,     // Disable mouse wheel navigation
            on: {
                init: function () {
                    const swiperAncestor = document.querySelector('.pageLayout__headline__layout__inner');
                    if (swiperAncestor) {
                        swiperAncestor.classList.add(classShow);
                    }
                },
            },
        });
    });
})();